<script>
  import { setCookie, getCookie } from './utils';
  import { Banner, Button } from 'flowbite-svelte';
  import { BullhornSolid, CloseSolid } from 'flowbite-svelte-icons';

  export let cookieKey;

  const hideAnnouncementBannerCookie = getCookie(cookieKey);

  export let hideAnnouncementBanner = false;

  $: {
    if (hideAnnouncementBannerCookie) {
      hideAnnouncementBanner = true;
    }
  }
</script>

{#if !hideAnnouncementBanner}
  <Banner position="static" dismissable={false} innerClass="w-full flex gap-2">
    <p
      class="flex-1 text-center text-sm font-normal text-gray-500 dark:text-gray-400"
    >
      <span
        class="me-3 inline-flex rounded-full bg-gray-200 p-1 dark:bg-gray-600"
      >
        <BullhornSolid class="h-3 w-3 text-gray-500 dark:text-gray-400" />
        <span class="sr-only">Light bulb</span>
      </span>
      <span>
        <slot />
      </span>
    </p>
    <div class="flex items-center">
      <Button
        on:click={() => {
          hideAnnouncementBanner = true;
          setCookie(cookieKey, true);
        }}
        outline={true}
        class="!p-2"
        size="lg"
        ><span class="sr-only">Close</span>
        <CloseSolid class="h-3 w-3" /></Button
      >
    </div>
  </Banner>
{/if}
